/**
 * Copyright (c) 2026, CYBRA Corp.
 */
import { Injectable } from '@angular/core';
import { Router } from '@angular/router';
import { Observable } from 'rxjs';

import { AuthenticationService } from './authentication.service';
import { BaseService } from './base-service';
import { RestService } from './rest-service';
import { ObjectProperty } from 'app/models/object-property';
import { PagedResults } from 'app/models/paged-results';
import { Url_Base } from 'app/rest-constants';

/* ============================================================
 * DTOs
 * ============================================================ */

export interface DataMappingColumnDto {
  id?: number;
  propertyId: number;
  propertyName?: string;
  isStatic: boolean;
  valueOrColumn?: string;
  isActive?: boolean;
  lookUp :boolean;
}

export interface DataMappingHeaderDto {
  id?: number;
  mappingName: string;
  objectId: number;
  objectUuid: string;
  objectName: string;
  objectCategory: string;
  description?: string;
  active: boolean;
  columns?: DataMappingColumnDto[];
}

export interface ObjectPropertyMappingVM extends ObjectProperty {
  propertyId: number;
  isStatic: boolean;
  valueOrColumn: string | null;
  lookUp: boolean;
}

@Injectable({ providedIn: 'root' })
export class DataMappingService extends BaseService {

  constructor(
    router: Router,
    authenticationService: AuthenticationService,
    private restService: RestService
  ) {
    super(router, authenticationService);
  }

  private baseUrl(): string {
    return `${Url_Base}/data-mapping/headers`;
  }



  /* ================= HEADERS ================= */

  getAllHeaders(): Promise<DataMappingHeaderDto[]> {
    return this.restService.get<DataMappingHeaderDto[]>(this.baseUrl());
  }

  getHeaderById(id: number): Promise<DataMappingHeaderDto> {
    return this.restService.get<DataMappingHeaderDto>(
      `${this.baseUrl()}/${id}`
    );
  }

  createHeader(header: DataMappingHeaderDto): Promise<DataMappingHeaderDto> {
    return this.restService.post<DataMappingHeaderDto>(this.baseUrl(), header);
  }

  updateHeader(header: DataMappingHeaderDto): Promise<DataMappingHeaderDto> {
    return this.restService.put<DataMappingHeaderDto>(this.baseUrl(), header);
  }




  deleteHeaders(headerIds: number[]): Promise<void> {
    const callUrl = this.baseUrl();
    return this.restService.delete<void>(callUrl, headerIds)
      .then(() => {
        return;
      });
  }


  
  /* ================= PAGING ================= */

  getHeadersPaging(
    start: number,
    size: number,
    order: string,
    filterString: string
  ): Promise<PagedResults<DataMappingHeaderDto>> {

    const url =
      `${this.baseUrl()}/paging` +
      `?start=${start}&size=${size}&order=${order}` +
      `&filterColumn=mappingName&filterString=${filterString}`;

    return this.restService.get<PagedResults<DataMappingHeaderDto>>(url);
  }
}


